export default "__VITE_ASSET__CV5QxsUL__"